import { usageAutorise, type DroitsImage, type UsageImage } from '@artosera/shared';
import { useTranslation } from 'react-i18next';

export function AvertissementDroitsImage({
  medias,
  usages,
}: {
  medias: readonly { droits?: DroitsImage | null }[];
  usages: readonly UsageImage[];
}) {
  const { t } = useTranslation('regie');
  const interdits = usages.filter((usage) =>
    medias.some((m) => !usageAutorise(m.droits, usage, new Date())),
  );
  if (!interdits.length) return null;
  return (
    <p role="status">
      {t('droitsImage.avertissement', {
        usages: interdits.map((usage) => t(`droitsImage.usages.${usage}`)).join(', '),
      })}
    </p>
  );
}
